export const SCREEN_NAME = '/logout_from_all_devices';
export const EVENT_CATEGORY = 'logout_from_all_devices';
export const DEFAULT_IVR = '1800120130';
export const PAYTM_CARE_URL = 'https://paytm.com/care';
